/**
 * Customer storefront channel header (hub-of-naturals, and later pryd-grains / pryd-liberia).
 * Not used by pryd-global-admin-app.
 */
export const CHANNEL_CODE_HEADER = 'X-Channel-Code';
